import { AggregateRoot } from "../../pascos/value_objects/aggregate_root";
import type { UniversityProps } from "../value_objects/university_props";
import type { UniqueEntityID } from "../../pascos/value_objects/unique_entity_Id";

// Aggregate Root
export class University extends AggregateRoot<UniversityProps> {
    private constructor(props: UniversityProps, id?: UniqueEntityID) {
        super(props, id);
    }

    // Factory method
    static create(props: UniversityProps, id?: UniqueEntityID): University {
        return new University(props, id);
    }

    // Getters
    get universityId(): string {
        return this._id.toValue();
    }

    get name(): string {
        return this.props.name;
    }

    get code(): string {
        return this.props.code;
    }

    get description(): string | null | undefined {
        return this.props.description;
    }

    get address(): string | null | undefined {
        return this.props.address;
    }

    get website(): string | null | undefined {
        return this.props.website;
    }

    get isActive(): boolean {
        return this.props.isActive;
    }

    get createdAt(): Date {
        return this.props.createdAt;
    }

    get updatedAt(): Date {
        return this.props.updatedAt;
    }

    // Domain behavior
    activate(): void {
        this.props.isActive = true;
        this.touch();
    }

    deactivate(): void {
        this.props.isActive = false;
        this.touch();
    }

    updateDetails(name: string, description?: string, address?: string, website?: string): void {
        this.props.name = name;
        if (description !== undefined) this.props.description = description;
        if (address !== undefined) this.props.address = address;
        if (website !== undefined) this.props.website = website;
        this.touch();
    }

    private touch(): void {
        this.props.updatedAt = new Date();
    }
}